<template>
    <tr>
                                        <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                            <div class="flex">
                                                <div class="flex-shrink-0 w-10 h-10">
                                                    <img
                                                        class="w-full h-full "
                                                        :src="imgType"
                                                        alt=""
                                                    />
                                                </div>
                                                
                                            </div>
                                        </td>
                                        <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                            <p class="text-gray-900 whitespace-no-wrap"> {{ inventory.attribute.available_stock }}</p>
                                            
                                        </td>
                                        <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                            <p class="text-gray-900 whitespace-no-wrap"> {{ inventory.attribute.total_sold_stock }}</p>
                                            
                                        </td>
                                        <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                            <span class="relative inline-block px-3 py-1 font-semibold my-black leading-tight">
                                                
                                            <span class=""> &#8358;{{ inventory.attribute.blood_price }}</span>
                                            </span>
                                        </td>
                                        <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-right">
                                            <button @click="add(inventory.attribute.blood_id)" class="bg-my-black p-2 rounded-md text-white hover:shadow-lg text-xs font-thin m-1">Add</button>
                                             <button @click="delPro(inventory.attribute.blood_id)" class="bg-red-500 p-2 rounded-md text-white hover:shadow-lg text-xs font-thin m-1">Drop</button>

                                        </td>
                                    </tr>
</template>
<script>

export default {
    name: 'Inventory-product',
    computed:{
        imgType(){
                
            switch (this.inventory.attribute.blood_type ){
                case 'a_positive': return '/img/blood/APlus.svg'
                break;
                case 'b_positive': return '/img/blood/BPlus.svg'
                break;
                case 'ab_positive': return '/img/blood/ABPlus.svg'
                break;
                case 'ab_negative': return '/img/blood/ABMinus.svg'
                break;
                case 'a_negative': return '/img/blood/AMinus.svg'
                break;
                case 'b_negative': return '/img/blood/BMinus.svg'
                break;
                 case 'o_negative': return '/img/blood/OMinus.svg'
                break;
                 case 'o_positive': return '/img/blood/OPlus.svg'
                break;
                
           }
           
    }
    },
    methods: {
        delPro(id){
            console.log(id)
            this.$emit('del', id)
        },
        add(id){
            console.log(id);
            this.$emit('add', id)
        }
    },
    
    props:['inventory', 'index']

}
</script>